import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './Alignment.scss';

/** Provides alignment to his children on different breakpoints.
 *  Narrow breakpoints prevail in case that a broader is not specified */
export const Alignment = ({ xs, sm, md, lg, children }) => (
  <div
    className={cx(
      { [styles[`alignment--xs--${xs}`]]: xs },
      { [styles[`alignment--sm--${sm}`]]: sm },
      { [styles[`alignment--md--${md}`]]: md },
      { [styles[`alignment--lg--${lg}`]]: lg }
    )}
  >
    {children}
  </div>
);

const alignments = [false, 'left', 'right', 'center', 'justify'];

Alignment.propTypes = {
  /** Alignment for the xs breakpoint */
  xs: PropTypes.oneOf(alignments),
  /** Alignment for the sm breakpoint */
  sm: PropTypes.oneOf(alignments),
  /** Alignment for the md breakpoint */
  md: PropTypes.oneOf(alignments),
  /** Alignment for the lg breakpoint */
  lg: PropTypes.oneOf(alignments)
};

Alignment.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false
};
